import React, {useEffect, useState} from 'react'
import { Container, Row } from 'react-bootstrap'
import Judul from './dashcomp/judul'
import CardProduk from './dashcomp/card_produk'
// import Produk from 'json/dashboard/produk'
import FormInput from 'components/componentsmall/form_input'
import { useHistory } from 'react-router'
import './style.css'
import axios from 'axios'
import { API_URL } from 'api'
import {access_token} from 'token'


export default function Produks() {
    const history = useHistory()
    const masukKeranjang = (value) => {
        // console.log("menu ", Produk[value])
        history.push('/product')
    }

    const [datas, setData] = useState([])
    const [requesError, setRequesError] = useState()

    async function getData(){
        try{
            const response = await axios.get(`${API_URL}/api/reseller/homepage/product`)
            setData(response.data.data[0].data.sub_data)
        } catch (err) {
            setRequesError(err.message)
        }
    }

    useEffect(() => {
        getData()
    }, [])

    axios.interceptors.request.use(
        config => {
            config.headers.authorization = `bearer ${access_token}`;
            return config
        },
        error => {
            return Promise.reject(error)
        }
    )

    // ingat dadalam row tepatnya di tag CardProduk ada mapingnya, tunggu data lebih dari 1.baru pasangkan mapnya
 

    return (
        <Container className="mt-4">
            <Judul judul="Produk" />
            <Row>
                 
                            <CardProduk 
                            onClick={() => masukKeranjang()}
                            header={datas.commision_rp}
                            src={`asset/dashboard/produk/img-1.png`} 
                            alt="produk"
                            text={datas.title} potongan={datas.discount}
                            price={datas.catalog_price}
                            />
                   
                {requesError && <p>{requesError}</p>}
            </Row>
            <div className="see-more">
                <FormInput
                cName="more" type="button" value="Lihat Produk Lainnya"
                />
            </div>
        </Container>
    )
}
